import React, { Component } from 'react';
import styled from 'styled-components'
import { Button, Card, Select, Divider, Input, Form, TreeSelect } from 'antd'
import { apiUtil as Util } from '../../mock/mockServices';

const { Option } = Select

const formItemLayout = {
  labelCol: {
    span: 4
  },
  wrapperCol: {
    span: 20
  }
};

let params = new URLSearchParams(window.location.search);
let menuId = params.get('id');

class MenuMgrComponent extends Component {

  state = {
    id: menuId,
    name: '',
    menuUrl: '',
    menuDesc: '',
    type: '',
    parentId: '',
    permissionId: '',
    menuTreeData: [],
    keyWords: '',
    sorter: {},
    pagination: {
      current: 1,
      pageSize: 9999,
      showTotal: total => `${total} items `,
      total: 0
    },
  }

  componentDidMount() {
    console.log("menuId", menuId)
    if (menuId !== "0" && menuId !== null && menuId !== "null") {
      Util.ajax.get('/admin/getMenuById', {
        id: menuId
      }).then(res => {
        const { data } = res
        if (!data) {
          return false
        }
        const { id, name, menuDesc, menuUrl, type, parentId, permissionId } = data

        this.setState({
          id: id,
          name: name ? name : '',
          menuDesc: menuDesc ? menuDesc : '',
          menuUrl: menuUrl ? menuUrl : '',
          type: type ? type : '',
          parentId: parentId ? parentId : '',
          permissionId: permissionId ? permissionId : '',
        }, () => {
          this.props.form.setFieldsValue({
            name: this.state.name,
            menuUrl: this.state.menuUrl,
            menuDesc: this.state.menuDesc,
            permissionId: this.state.permissionId,
            type: this.state.type,
            parentId: this.state.parentId,
          });
        })
      })
    }

    const { pagination, keyWords } = this.state

    Util.ajax.get('/admin/filterMenuList', {
      keyWords: keyWords,
      current: pagination.current,
      pageSize: pagination.pageSize
    }).then(res => {
      pagination.total = res.data.total
      if (pagination.total > 0) {
        this.setState({
          menuTreeData: Util.transformData(Util.arrayToTree(res.data.list)),
          pagination,
        })
      }
    })
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, value) => {
      console.log(value)
      if (!err) {
        if (menuId !== "0") {
          Util.ajax.post('/admin/createMenu', value).then(res => {
            Util.message.success('Save Successful')
          })
        } else {
          Util.ajax.post('/admin/editMenu', value).then(res => {
            Util.message.success('Save Successful')
          })
        }
      }
    });
  }

  handleClear = e => {
    e.preventDefault();
    this.setState({
      id: null,
      name: '',
      menuDesc: '',
      menuUrl: '',
      type: '',
      parentId: null,
      permissionId: '',
    }, () => {
      this.props.form.setFieldsValue({
        name: this.state.name,
        menuUrl: this.state.menuUrl,
        menuDesc: this.state.menuDesc,
        permissionId: this.state.permissionId,
        type: this.state.type,
        parentId: this.state.parentId,
      });
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form layout="horizontal" {...formItemLayout} style={{ width: '660px' }} onSubmit={this.handleOk}>
        <Form.Item label="Menu Name">
          {getFieldDecorator('name', {
            initialValue: this.state.name,
            rules: [
              { required: true, message: 'Please enter the menu name', whitespace: true },
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item label="Menu URL">
          {getFieldDecorator('menuUrl', {
            initialValue: this.state.menuUrl,
            rules: [
              { required: true, message: 'Please enter the menu address', whitespace: true },
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item label="Menu Description">
          {getFieldDecorator('menuDesc', {
            initialValue: this.state.menuDesc,
            rules: [
              { required: true, message: 'Please enter the menu description', whitespace: true },
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item label="Permission ID">
          {getFieldDecorator('permissionId', {
            initialValue: this.state.permissionId,
            rules: [
              { required: true, message: 'Please enter the permission identifier', whitespace: true },
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item label="Menu Type">
          {getFieldDecorator('type', {
            initialValue: this.state.type ? this.state.type : '1',
            rules: [
              { required: true, message: 'Please enter the resource type', whitespace: true },
            ]
          })(<Select onChange={value => this.props.form.setFieldsValue({ type: value })}>
            <Option value='1'>Menu</Option>
            <Option value='2'>Page</Option>
            <Option value='3'>Button</Option>
          </Select>)}
        </Form.Item>
        <Form.Item label="Parent Menu id">
          {getFieldDecorator('parentId', {
            initialValue: this.state.parentId,
            rules: [
              { required: false, message: 'Please select the parent menu' },
            ]
          })(
            <TreeSelect
              treeData={this.state.menuTreeData}
              placeholder="Please select the parent menu"
              treeDefaultExpandAll
            />
          )}
        </Form.Item>
        <Form.Item label="" wrapperCol={{ push: 4 }}>
          <Button className="mr20" onClick={this.handleClear}>Clear</Button>
          <Button type="primary" onClick={this.handleSubmit}>Save</Button>
        </Form.Item>
      </Form>
    )
  }
}

const MenuMgrForm = Form.create({ name: 'org-mgr-form' })(MenuMgrComponent)

export default class OrgMgr extends Component {

  render() {
    const isNew = menuId === "0";
    return (
      <Root>
        <div className="page-content">
          <Card title={
            <div style={{ fontSize: '22px', fontWeight: 'bold' }}>System Menu Management</div>
          } bordered={false} style={{ width: '100%' }}>
            {/* <div className="title"></div>
                        <Divider></Divider> */}
            <div className="sub-title">
              {isNew ? (
                <div>Add Menu Item</div>
              ) : (
                <div>Edit Menu Item (id: {menuId})</div>
              )}
            </div>
            <Divider></Divider>
            <MenuMgrForm></MenuMgrForm>
          </Card>
        </div>
      </Root>
    )
  }
}

const Root = styled.div`
    .title{
        font-size: 22px;
        font-weight: bold;
    }
    .sub-title{
        font-size:18px;
        font-weight: bold;
        padding: 5px 0 15px;
    }
`
